// Sequential YlOrRd 5-class scale (light = few visits, dark red = many).
export const INTENSITY_SCALE = ['#ffffb2', '#fecc5c', '#fd8d3c', '#f03b20', '#bd0026']

export function intensityColor(weight: number, maxWeight: number): string {
  const max = maxWeight > 0 ? maxWeight : 1
  const t = Math.min(1, weight / max)
  const idx = Math.min(INTENSITY_SCALE.length - 1, Math.floor(t * INTENSITY_SCALE.length))
  return INTENSITY_SCALE[idx]
}
